import { HttpParams } from '@angular/common/http';
import { Router }     from '@angular/router';

import * as moment from 'moment';

import { RestPaginationAndSortingParams } from '@models/rest/rest-pagination-and-sorting-params';
import { GenericOption }                  from '@models/utils/generic-option';


const restPaginationDefaults: RestPaginationAndSortingParams = {
  page:          null,
  size:          24,
  sortProperty:  'datInclusao',
  sortDirection: 'desc'
};

export class TransformClass {

  public static getUrlWithoutParams(router: Router) {
    const urlTree       = router.parseUrl(router.url);
    urlTree.queryParams = {};

    return urlTree.toString();
  }

  /**
   * Converts a string into a URL-friendly slug by removing accents,
   * replacing spaces with dashes, and removing special characters.
   * @param value - The string to convert into a slug
   * @returns The slugified string or empty string if no value provided
   */
  public static slugify(value: string): string {
    if (!value) return '';

    return value.normalize('NFKD') // Normalize Unicode characters (decompose and remove diacritics)
                .replace(/[\u0300-\u036f]/g, '') // Remove combining diacritical marks
                .replace(/[\s\/]+/g, '-') // Replace spaces and slashes with dashes
                .replace(/[^\w\-]+/g, '') // Remove all non-word chars (except dashes)
                .toLowerCase();

  }

  public static ptBrList(list: ( string | number )[]): string {
    if (list.length === 0) return '';
    if (list.length === 1) return `${ list[ 0 ] }`;

    const last: string | number         = list[ list.length - 1 ],
          others: ( string | number )[] = list.slice(0, -1);

    return `${ others.join(', ') } e ${ last }`;
  }

  public static httpParams(params: object): HttpParams {
    const strParams = {};

    const isValidParam = (param: unknown) => param || Number.isInteger(param) || param === false;

    for (const key in params) {
      if (params.hasOwnProperty(key) && isValidParam(params[ key ])) {
        strParams[ key.toString() ] = params[ key ].toString();
      }
    }

    return new HttpParams({ fromObject: strParams });
  }

  public static formatPaginationParams(params: RestPaginationAndSortingParams): {
    page: number,
    size: number,
    sort: string
  } {
    const { page, size, ...sortParams }: Partial<RestPaginationAndSortingParams> = {
      ...restPaginationDefaults,
      ...params
    };

    const sort: string = `${ sortParams.sortProperty },${ sortParams.sortDirection }`;

    return { page, size, sort };
  }

  public static moment2String(
    date: moment.Moment,
    format: string = 'DD/MM/YYYY'
  ): string {
    return !date ? null : date.format(format);
  }

  public static string2Moment(
    date: string,
    format: string = 'DD/MM/YYYY HH:mm'
  ): moment.Moment {
    if (!date) return null;
    return moment(date, format);
  }

  public static getYearsArray(from: number) {
    const currentYear = moment().year();

    return Array.from(
      { length: currentYear - from + 1 },
      (_value, index) => from + index
    ).reverse();
  }

  public static getMonthOptions(): GenericOption<number>[] {
    return moment.months().map((month: string, index: number) => ( {
      label: month, value: index + 1
    } ));
  }

  public static compareObjects = (a: object, b: object) => JSON.stringify(a) === JSON.stringify(b);
}
